import { createSlice } from "@reduxjs/toolkit";

import { addPersonalDetailsChefAPI } from "../../../../api/chef";
import { sliceHandler } from "../../utils";

const addPersonalDetailsChef = createSlice(
    sliceHandler({
        name: 'addPersonalDetailsChef',
        action: 'addPersonalDetailsChefSlice',
        success: 'addPersonalDetailsChefSliceSuccess',
        failure: 'addPersonalDetailsChefSliceFailure',
        reset: 'addPersonalDetailsChefSliceReset'
    })
);

const addPersonalDetailsChefAction: any = addPersonalDetailsChef.actions;
const addPersonalDetailsChefHandler = (data: any) => async (dispatch: any) => {
    try {
        dispatch(addPersonalDetailsChefAction.addPersonalDetailsChefSlice());
        const response: any = await addPersonalDetailsChefAPI(data);
        dispatch(addPersonalDetailsChefAction.addPersonalDetailsChefSliceSuccess(response));
    } catch (e: any) {
        dispatch(addPersonalDetailsChefAction.addPersonalDetailsChefSliceFailure(e?.response?.data));
    }
};

export {
    addPersonalDetailsChefAction,
    addPersonalDetailsChefHandler,
}

export default addPersonalDetailsChef.reducer;